<div class="popup-header" >
        <div><img src="assets/images/black-close.svg" alt="" (click)="close()" class="close" aria-label="Close"  >
            <div class="graph-export-div" 
            [ngStyle]="{
            'width':  popUpTitle == 'LANDING_DASHBOARD.LBL_REJECT' ? '650px':'',
            'height': popUpTitle == 'LANDING_DASHBOARD.LBL_REJECT'? '350px' : (containerHeight ? containerHeight + 'px' : '100%')
          }"  ></div>
         </div>
</div>
   
